"use client";

import Image from "next/image";
export function Productduction() {
  return <div className="mt-12 grid w-[800px] grid-cols-3 gap-4" data-sentry-component="Productduction" data-sentry-source-file="Introduction.tsx">
      <CommmonBox imageUrl="/aiTool/introduction1.webp" title="选择带货商品和分析卖点" subTitle="输入亚马逊/TikTok商品链接或名称，一键分析卖点" data-sentry-element="CommmonBox" data-sentry-source-file="Introduction.tsx" />
      <CommmonBox imageUrl="/aiTool/introduction2.webp" title="选择句型和视频风格" subTitle="智能推荐高转化视频句型，自定义选择句型和视频风格" data-sentry-element="CommmonBox" data-sentry-source-file="Introduction.tsx" />
      <CommmonBox imageUrl="/aiTool/introduction3.webp" title="脚本精细调整" subTitle="根据目标受众、情绪反应精准调整内容，一键开启 AI 深度思考模式" data-sentry-element="CommmonBox" data-sentry-source-file="Introduction.tsx" />
    </div>;
}
export function VideoIntroduction() {
  return <div className="mt-12 grid w-[800px] grid-cols-3 gap-4" data-sentry-component="VideoIntroduction" data-sentry-source-file="Introduction.tsx">
      <CommmonBox imageUrl="/aiTool/introduction4.webp" title="选择仿写视频" subTitle="输入视频链接或名称选择仿写视频，一键智能分析文案和句型" data-sentry-element="CommmonBox" data-sentry-source-file="Introduction.tsx" />
      <CommmonBox imageUrl="/aiTool/introduction2.webp" title="选择商品、句型和风格" subTitle="选择亚马逊/Tiktok商品，自定义选择卖点、句型和视频风格" data-sentry-element="CommmonBox" data-sentry-source-file="Introduction.tsx" />
      <CommmonBox imageUrl="/aiTool/introduction3.webp" title="脚本精细调整" subTitle="根据目标受众、情绪反应精准调整内容，一键开启 AI 深度思考模式" data-sentry-element="CommmonBox" data-sentry-source-file="Introduction.tsx" />
    </div>;
}
export function InspirationIntroduction() {
  return <div className="mt-8 grid w-[900px] grid-cols-3 gap-4" data-sentry-component="InspirationIntroduction" data-sentry-source-file="Introduction.tsx">
      <CommmonBox imageUrl="/aiTool/introduction5.webp" title="全球创意内容探索" subTitle="探索最相关的创意内容，并基于智能聚类分析，为您提供精准的创作方向" data-sentry-element="CommmonBox" data-sentry-source-file="Introduction.tsx" />
      <CommmonBox imageUrl="/aiTool/introduction6.webp" title="多维创意指标分析" subTitle="通过带货转化、播放量、热度等核心指标，量化解析优质素材特征" data-sentry-element="CommmonBox" data-sentry-source-file="Introduction.tsx" />
      <CommmonBox imageUrl="/aiTool/introduction7.webp" title="素材创意要素洞察" subTitle="智能解构素材要素，从内容呈现、表现形式到受众偏好，全方位揭示爆款密码" data-sentry-element="CommmonBox" data-sentry-source-file="Introduction.tsx" />
    </div>;
}
function CommmonBox({
  imageUrl,
  title,
  subTitle
}: {
  imageUrl: string;
  title: string;
  subTitle: string;
}) {
  return <div className="overflow-hidden rounded-lg border" data-sentry-component="CommmonBox" data-sentry-source-file="Introduction.tsx">
      <div className="relative h-[180px] w-full">
        <Image fill src={imageUrl} alt="introduction" className="object-cover" data-sentry-element="Image" data-sentry-source-file="Introduction.tsx" />
      </div>
      <div className="flex flex-col gap-1 bg-white p-4">
        <span className="text-sm font-medium text-[#1E286B]">{title}</span>
        <span className="text-xs text-[#676A70]">{subTitle}</span>
      </div>
    </div>;
}